import { useTranslation } from "react-i18next";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { useMarket } from "../../../store/hooks/useMarket";
import { Wizard } from "../../../store/interfaces/Wizard";
import CustomContainer from "../../shared/CustomContainer";
import ContactUsStepItem from "./ContactUsStepItem";
import MachineTonnageStepItem from "./MachineTonnageStepItem";
import MarketStepItem from "./MarketStepItem";
import OptionalStepItem from "./OptionalStepItem";
import ProductStepItem from "./ProductStepItem";
import "./WizardHeader.scss";
interface WizardHeaderProps {
  wizard: Wizard;
}

const WizardHeader = ({ wizard }: WizardHeaderProps) => {
  const { t } = useTranslation("wizard");
  const market = useMarket();
  const mediumScreen = 720;
  let nrOfSlideItems = 3;
  const { width } = useWindowDimensions();

  if (width > mediumScreen) {
    nrOfSlideItems = 5;
  }

  if (!wizard) {
    return (
      <div className="wizardHeaderContainer">
        <div className="wizardHeader"></div>
      </div>
    );
  }

  const { activeStepIndex } = wizard;
  return (
    <div className="wizardHeaderContainer">
      <>
        <Swiper
          slidesPerView={nrOfSlideItems}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="mySwiper"
        >
          <CustomContainer>
            <div className="wizardHeader">
              <SwiperSlide>
                <MarketStepItem
                  activeStepIndex={activeStepIndex}
                  market={market}
                  text={t("marketstep")}
                />
              </SwiperSlide>
              <SwiperSlide>
                <MachineTonnageStepItem
                  activeStepIndex={activeStepIndex}
                  market={market}
                  text={t("machinetonnagestep")}
                />
              </SwiperSlide>
              <SwiperSlide>
                <ProductStepItem
                  activeStepIndex={activeStepIndex}
                  market={market}
                  text={t("productstep")}
                />
              </SwiperSlide>
              <SwiperSlide>
                <OptionalStepItem
                  activeStepIndex={activeStepIndex}
                  market={market}
                  text={t("otheroptionsstep")}
                />
              </SwiperSlide>
              <SwiperSlide>
                <ContactUsStepItem
                  activeStepIndex={activeStepIndex}
                  market={market}
                  text={t("contactusstep")}
                />
              </SwiperSlide>
            </div>
          </CustomContainer>
        </Swiper>
      </>
    </div>
  );
};

export default WizardHeader;
